var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Site } from '@debbie/common/dist';
import { PropertyDataType, } from '@debbie/common/dist/properties';
import * as files from '@debbie/cortex/dist/api/files';
import { Select, Loading, Textarea, Input, Checkbox, AddressInput, DateInput, Modal, Well, MoneyInput, File, } from '..';
import THEME from '../../theme';
import Clock from '../Icons/Clock';
import Info from '../Icons/Info';
import ThumbsUp from '../Icons/ThumbsUp';
import PropertyHistory from './PropertyHistory';
import PropertyTypeInfo from './PropertyTypeInfo';
let tId; // NodeJS.Timer
const PropertyCmp = (props) => {
    var _a, _b;
    const { updateProperty } = props;
    const site = useSelector((s) => s.site);
    const lang = useSelector((s) => s.lang);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [infoModalOpen, setInfoModalOpen] = useState(false);
    useEffect(() => {
        var _a;
        setData((_a = props.property) === null || _a === void 0 ? void 0 : _a.data);
    }, [props.property]);
    const onToggle = () => {
        setModalOpen(!modalOpen);
    };
    const getProperty = () => {
        var _a, _b, _c;
        {
            switch (props.propertyType.type) {
                case PropertyDataType.checkbox:
                    return (React.createElement(Checkbox, { disabled: !props.editable, checked: typeof data === 'boolean' ? data : false, onChange: (e) => {
                            setData(e.target.checked);
                            updateProperty(propertyType.handle, propertyType.ref, props.refId, e.target.checked, propertyType.type, setLoading, setDone);
                        } }));
                case PropertyDataType.address:
                    return (React.createElement("div", null,
                        React.createElement(AddressInput, { address: data, disabled: !props.editable, onChange: (address) => {
                                setData(address);
                                updateProperty(propertyType.handle, propertyType.ref, props.refId, address, propertyType.type, setLoading, setDone);
                            } })));
                case PropertyDataType.datePicker:
                    return (React.createElement(DateInput, { placeholder: propertyType.label, onChange: (date) => {
                            const _date = date ? moment(date).format() : null;
                            setData(_date);
                            updateProperty(propertyType.handle, propertyType.ref, props.refId, _date, propertyType.type, setLoading, setDone);
                        }, value: typeof data === 'string' ? moment(data) : null, allowNull: true, disabled: !props.editable }));
                case PropertyDataType.dropdown:
                    return (React.createElement(Select, { disabled: !props.editable, onChange: (e) => {
                            const val = e.target.value || null;
                            setData(val);
                            updateProperty(propertyType.handle, propertyType.ref, props.refId, val, propertyType.type, setLoading, setDone);
                        }, value: typeof data === 'string' ? data : null },
                        React.createElement("option", null, "-"), (_b = (_a = propertyType.data) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 :
                        _b.map((option, index) => (React.createElement("option", { key: index, value: option.value }, option.text)))));
                case PropertyDataType.file:
                    return (React.createElement("div", null,
                        //@ts-ignore
                        React.createElement(Dropzone, { disabled: !props.editable, acceptStyle: {
                                backgroundColor: 'grey',
                            }, className: "dropzone", onDrop: (acceptedFiles) => __awaiter(void 0, void 0, void 0, function* () {
                                const newData = yield onDrop(acceptedFiles, propertyType.handle, propertyType.ref, props.refId, setLoading, setDone);
                                setData(newData);
                            }) }, "Drop file here"),
                        (data === null || data === void 0 ? void 0 : data.fileId) && (React.createElement("div", null,
                            React.createElement(File
                            // @ts-ignore
                            , { 
                                // @ts-ignore
                                file: data, onRemove: () => {
                                    setData(null);
                                    updateProperty(propertyType.handle, propertyType.ref, props.refId, null, propertyType.type, setLoading, setDone);
                                }, removable: true })))));
                case PropertyDataType.money:
                    return (React.createElement(MoneyInput, { disabled: !props.editable, placeholder: `${propertyType.label} [${(data === null || data === void 0 ? void 0 : data.currency) ? data.currency : ''}]`, value: data && typeof data.amount === 'number' ? data.amount : null, allowNull: true, onChange: (money) => {
                            const moneyData = { amount: money, currency: data === null || data === void 0 ? void 0 : data.currency };
                            setData(moneyData);
                            if (typeof money === 'number') {
                                clearTimeout(tId);
                                tId = setTimeout(() => {
                                    updateProperty(propertyType.handle, propertyType.ref, props.refId, { amount: money, currency: data === null || data === void 0 ? void 0 : data.currency }, propertyType.type, setLoading, setDone);
                                }, 600);
                            }
                        } }));
                case PropertyDataType.singleLineText:
                    return (React.createElement(Input, { disabled: !props.editable, placeholder: propertyType.label, value: typeof data === 'string' ? data : '', onChange: (e) => {
                            const { value } = e.target;
                            setData(value);
                        }, onSubmit: data !== ((_c = props.property) === null || _c === void 0 ? void 0 : _c.data)
                            ? () => {
                                updateProperty(propertyType.handle, propertyType.ref, props.refId, data ? data : null, propertyType.type, setLoading, setDone);
                            }
                            : undefined }));
                case PropertyDataType.multiLineText:
                    return (React.createElement(Textarea, { disabled: !props.editable, value: typeof data === 'string' ? data : '', style: { marginBottom: '0 !important' }, placeholder: propertyType.label, onChange: (e) => {
                            const { value } = e.target;
                            const val = value ? value : null;
                            setData(val);
                            clearTimeout(tId);
                            tId = setTimeout(() => {
                                updateProperty(propertyType.handle, propertyType.ref, props.refId, val, propertyType.type, setLoading, setDone);
                            }, 600);
                        } }));
                case PropertyDataType.number:
                    return (React.createElement(Input, { disabled: !props.editable, placeholder: propertyType.label, type: "number", value: typeof data === 'string' ? `${data}` : '', onChange: (e) => {
                            const { value } = e.target;
                            setData(value);
                            const val = value && !Number.isNaN(parseFloat(value))
                                ? parseFloat(value)
                                : null;
                            clearTimeout(tId);
                            tId = setTimeout(() => {
                                updateProperty(propertyType.handle, propertyType.ref, props.refId, val, propertyType.type, setLoading, setDone);
                            }, 600);
                        } }));
                default:
                    return React.createElement("div", null);
            }
        }
    };
    const onDrop = (acceptedFiles, handle, ref, refId, setLoading, setDone) => __awaiter(void 0, void 0, void 0, function* () {
        const file = acceptedFiles[0];
        const fileReaded = (yield promiseFileReader(file)).split('base64,')[1];
        if (file && fileReaded) {
            const res = yield files.save({
                name: file.name,
                contentType: file.type,
                content: fileReaded,
            });
            yield updateProperty(handle, ref, refId, res.file, PropertyDataType.file, setLoading, setDone);
            return res.file;
        }
        else {
            alert('Error');
            return null;
        }
    });
    const promiseFileReader = (file) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => __awaiter(void 0, void 0, void 0, function* () {
                resolve(event.target.result);
            });
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    });
    const { propertyType } = props;
    return (React.createElement(PropertyStyled, null,
        React.createElement("div", null,
            React.createElement("span", { className: "label" },
                propertyType.label,
                propertyType.required && '*'),
            React.createElement("span", { className: "description" },
                site === Site.Caseworker && !(loading || done) ? (React.createElement(Clock, { style: {
                        marginRight: '4px',
                    }, "data-tooltip-content": lang.properties.historical, "data-tooltip-id": "tooltip-default", onClick: onToggle })) : (React.createElement(React.Fragment, null, done ? (React.createElement(ThumbsUp, { style: {
                        marginRight: '4px',
                    } })) : (React.createElement("span", { style: {
                        marginRight: '4px',
                    } }, loading && React.createElement(Loading, { width: "13px" }))))),
                React.createElement(Info, { "data-tooltip-content": `${propertyType.description}
[${propertyType.handle}]`, "data-tooltip-id": "tooltip-default", style: { cursor: 'pointer' }, onClick: () => setInfoModalOpen(!infoModalOpen) }))),
        React.createElement("div", { className: "content" }, getProperty()),
        site === Site.Caseworker && modalOpen && ((_a = props.property) === null || _a === void 0 ? void 0 : _a.refId) && (React.createElement(PropertyHistory, { onToggle: onToggle, property: {
                propRef: props.propertyType.ref,
                propRefId: (_b = props.property) === null || _b === void 0 ? void 0 : _b.refId,
                handle: props.propertyType.handle,
            } })),
        site === Site.Caseworker && infoModalOpen && (React.createElement(Modal, { maxWidth: "500px", onToggle: () => setInfoModalOpen(!infoModalOpen), header: "Info" },
            React.createElement("h3", null, lang.properties.description),
            React.createElement(Well, null, propertyType.description),
            React.createElement("h3", null, lang.properties.handle),
            React.createElement(Well, null, propertyType.handle),
            React.createElement("h3", null, lang.properties.usage),
            React.createElement(Well, null,
                React.createElement(PropertyTypeInfo, { property: propertyType }))))));
};
export default PropertyCmp;
const SearchInputWrapperStyled = styled.div `
  .search-results {
    margin-top: 20px;
  }
`;
const PropertyStyled = styled.div `
  .label {
    font-weight: bold;
    font-size: 0.8em;
    text-transform: uppercase;
  }

  .description {
    float: right;
  }

  .content {
    margin: 8px 0;
    font-size: 1.3em;
  }

  .dropzone {
    background-color: ${THEME.COLOR_SECONDARY};
    padding: 20px 15px 20px 15px;
    text-align: center;
    margin-bottom: 20px;
    width: 100%;
    border-radius: 3px;
    border: 1px solid #ccc;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-sizing: border-box;
    color: #cccccc;
    font-size: 0.7em;
  }
`;
//# sourceMappingURL=Property.js.map